/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function previewImage(options, context) {
    var _a;
    var api = 'dd.biz.util.previewImage';
    var formatInput = function (input) {
        var _a, _b;
        var current = (_a = input === null || input === void 0 ? void 0 : input.urls) === null || _a === void 0 ? void 0 : _a[0];
        if (input.current !== undefined) {
            current = (_b = input === null || input === void 0 ? void 0 : input.urls) === null || _b === void 0 ? void 0 : _b[Number(input.current)];
        }
        return { current: current };
    };
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput });
}

export { previewImage as default };
